import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import LoginForm from '../components/Login/LoginForm';
import RecoverForm from '../components/Login/RecoverForm';
import RegisterForm from '../components/Login/RegisterForm';
import CompanyCreationForm from '../components/Login/CompanyCreationForm';
import loginImage from '../static/ColourBrandPrimary2x.png';
import '../style/Login.css';

type LoginView = 'login' | 'recover' | 'register' | 'createCompany';

const Login: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [currentView, setCurrentView] = useState<LoginView>('login');
    const [companyToken] = useState<string>('');

    // Check for token in URL (from email links)
    const tokenFromUrl = searchParams.get('token');

    useEffect(() => {
        // Framekiller script with null check
        if (window.top !== null && window.top !== window.self) {
            window.top.location = window.self.location;
        }
    
        document.body.classList.add("login-page");
        
        // If there's a token in the URL, automatically show company creation form
        if (tokenFromUrl) {
            setCurrentView('createCompany');
        }
        
        return () => {
            document.body.classList.remove("login-page");
        };
    }, [tokenFromUrl]);
    const isWideView = currentView === 'register' || currentView === 'createCompany';
    const isRegisterView = currentView === 'register';
    const containerClassName = `login-container${isWideView ? ' login-container--wide' : ''}`;

    return (
        <div className="login-view">
            {isRegisterView ? (
                <div className="login-register-layout">
                    <div className="image-container login-register-image-container">
                        <img src={loginImage} alt="Login" className="login-image login-image--register" />
                    </div>
                    <div className="form-container login-register-form-container">
                        <RegisterForm onBackToLogin={() => setCurrentView('login')} />
                    </div>
                </div>
            ) : (
                <div className={containerClassName}>
                    <div className="image-container">
                        <img src={loginImage} alt="Login" className="login-image" />
                    </div>
                    <div className="form-container">
                        {currentView === 'login' && (
                            <LoginForm 
                                onRecoverPassword={() => setCurrentView('recover')} 
                                onRegister={() => setCurrentView('register')}
                            />
                        )}
                        {currentView === 'recover' && (
                            <RecoverForm onBackToLogin={() => setCurrentView('login')} />
                        )}
                        {currentView === 'createCompany' && (
                            <CompanyCreationForm 
                                token={tokenFromUrl || companyToken} 
                                onBackToLogin={() => setCurrentView('login')} 
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Login;
